import { motion } from 'motion/react';
import { Target, Users, Zap } from 'lucide-react';
import { GlassCard } from '../ui/GlassCard';

export const AboutSection = () => {
  const features = [
    {
      icon: Target,
      title: "Precyzja Celu",
      desc: "Nie marnujemy czasu na teorię. Dostajesz gotowe schematy działania, które generują wyniki od pierwszego dnia."
    },
    {
      icon: Users,
      title: "Elitarna Sieć",
      desc: "Dołącz do społeczności ludzi, którzy wybrali mądrą pracę. Twój kapitał to ludzie, którzy mierzą wysoko."
    },
    {
      icon: Zap,
      title: "AI Advantage",
      desc: "Wyprzedź rynek dzięki narzędziom, o których inni dopiero usłyszą za rok. Bądź pionierem."
    }
  ];

  return (
    <section id="about" className="min-h-screen flex items-center justify-center py-20 bg-surface/30 relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">

        <motion.div
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <h2 className="text-4xl md:text-6xl font-display font-bold text-text-main mb-6">
            KIM <span className="text-primary">JESTEŚMY?</span>
          </h2>
          <div className="w-20 h-1 bg-primary mb-8" />
          <p className="text-lg text-text-muted mb-6 leading-relaxed">
            Akademia Milionerów to nie kolejny kurs online. To ekosystem zaprojektowany dla ludzi, którzy rozumieją, że w XXI wieku ciężka praca to za mało. Liczy się mądra praca.
          </p>
          <p className="text-lg text-text-muted mb-8 leading-relaxed">
            Jesteśmy grupą praktyków, wizjonerów i technologicznych entuzjastów. Łączymy tradycyjne wartości biznesowe z potęgą sztucznej inteligencji.
          </p>

          <div className="grid grid-cols-2 gap-8">
            <div>
              <div className="text-4xl font-display font-bold text-text-main mb-1">5000+</div>
              <div className="text-xs font-mono text-primary uppercase tracking-wider">Partnerów</div>
            </div>
            <div>
              <div className="text-4xl font-display font-bold text-text-main mb-1">12M+</div>
              <div className="text-xs font-mono text-primary uppercase tracking-wider">Wygenerowanego Zysku</div>
            </div>
          </div>
        </motion.div>

        <div className="grid grid-cols-1 gap-6">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6, delay: index * 0.2 }}
              viewport={{ once: true }}
            >
              <GlassCard className="flex items-start gap-4 p-6 hover:bg-surface-highlight/50 transition-colors">
                <div className="text-primary shrink-0">
                  <feature.icon size={24} />
                </div>
                <div>
                  <h3 className="text-xl font-bold text-text-main mb-2">{feature.title}</h3>
                  <p className="text-sm text-text-muted leading-relaxed">{feature.desc}</p>
                </div>
              </GlassCard>
            </motion.div>
          ))}
        </div>

      </div>
    </section>
  );
};
